import { Box, Button, Card, LinearProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  headerRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
  },
  studentName: {
    fontWeight: 'bold',
    wordBreak: 'break-word',
  },
  changeCodeButton: {
    minWidth: 'auto',
    padding: theme.spacing(0.5, 1),
  },
  progressRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
  },
  progressText: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    whiteSpace: 'nowrap',
  },
  progressBar: {
    flex: 1,
    borderRadius: 4,
    height: 6,
  },
}));

export function StudentProgressCard({ studentName, answeredCount, totalQuestions, onChangeCode }) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <Box className={classes.headerRow}>
        <Typography variant="subtitle1" className={classes.studentName}>
          {studentName}
        </Typography>
        <Button
          className={classes.changeCodeButton}
          size="small"
          color="primary"
          onClick={onChangeCode}
        >
          Trocar
        </Button>
      </Box>
      <Box className={classes.progressRow}>
        <Typography className={classes.progressText}>
          {answeredCount} de {totalQuestions} questões
        </Typography>
        <LinearProgress
          className={classes.progressBar}
          variant="determinate"
          value={totalQuestions ? (answeredCount * 100 / totalQuestions) : 0}
        />
      </Box>
    </Card>
  );
}
